module.exports = __webpack_public_path__ + "img/credit_card.4b195cd2.svg";